import { createContext, useContext } from 'react';

// Optimistic edits to the movement lists App.js holds (Movimientos and Inicio's
// recent list), so add/edit/delete show at once instead of after the API call
// plus a full refetch (~2–3 s on a phone). The refetch that follows each
// mutation stays the source of truth and corrects anything applied here.
//   upsert(txn)          insert or replace by id
//   remove(id)
//   replace(oldId, txn)  swap a temporary row for the saved one
const noop = () => {};
export const LocalTransactionsContext = createContext({ upsert: noop, remove: noop, replace: noop });

export const useLocalTransactions = () => useContext(LocalTransactionsContext);
